global.conmed = global.conmed || {};

conmed.responsive_product_img = function ($) {
    'use strict';
    var that = {
        selectors: {
            img: '.js-responsive-product-img',
        }
    };

    that.init = function () {
        let images = $(that.selectors.img);
        images.each(that.setImgSize);

        $(window).on("resize", function () {

            if (that.delay) {
                clearTimeout(that.delay);
            }

            that.delay = setTimeout(function () {

                images.each(that.setImgSize);
            }, 500);
        });
    };

    that.getViewport = function () {
        let md = 768;
        if (window.innerWidth >= md) {
            return "md";
        } else {
            return "sm";
        }
    };

    that.setImgSize = function () {
        let elm = $(this);
        let sm = elm.data("img-sm");
        let md = elm.data("img-md");
        // Always use mobile image, fall back to desktop if mobile not available
        let result = sm || md;

        let source = "url('" + result + "')";
        elm.css("background-image", source);
    };

    return that;
}(jQuery);